import { TextField } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'

import { DesignSystem } from '../../../../../../../../../../../../../../enums/designSystem'
import { useFormContext } from '../../../../../../../../../../../../../../hooks/useForm'
import type { SupplierFormSchema } from '../../../../../../types/supplierForm'

export const CompanyPhone = () => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<SupplierFormSchema, DesignSystem.Lumen>({ designSystem: DesignSystem.Lumen })

  return (
    <FormItem
      name="phone"
      render={({ error, field }) => (
        <TextField
          {...field}
          error={error}
          label={t('suppliers.detail.form.phone.label')}
          placeholder={t('suppliers.detail.form.phone.placeholder')}
          size="small"
          type="tel"
        />
      )}
    />
  )
}
